import * as React from 'react';
import { action, observable } from 'mobx';
import { API, APIErrorMap, SendVoucherResponse, SendVoucherValidationErrorKeys } from '../../api/api';
import { Passenger } from '../../models/passenger';
import { AppStore } from '../../stores/app-store';
import bind from 'bind-decorator';
import { unreachable } from '../../utils/compose';

// tslint:disable:readonly-keyword

export class SendVoucherStore {
  @observable public loading = false;
  @observable public email = '';
  @observable public emailSent = false;
  @observable public sendError = false;
  @observable public lastSendVoucherErrors: APIErrorMap<SendVoucherValidationErrorKeys> = {};

  constructor(private readonly appStore: AppStore, private readonly api: API, private readonly passenger: Passenger) { }

  @bind
  @action
  public setEmail(email: string) {
    this.email = email;
  }

  @bind
  @action
  public async handleClickSendVoucher(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();

    if (!this.appStore.pnr || !this.appStore.lastName)
      throw new Error('bug');

    this.loading = true;

    const response = await this.api.sendVoucher(this.email, this.appStore.pnr, this.appStore.lastName, this.passenger);
    await this.handleSendVoucherResponse(response);
  }

  @action
  public async handleSendVoucherResponse(response: SendVoucherResponse) {
    this.loading = false;

    switch (response.status) {
      case 'ok':
        this.handleSendSuccess(response.passenger);
        break;

      case 'network-error':
      case 'unexpected-error':
        this.handleSendError();
        break;

      case 'validation-error':
        this.lastSendVoucherErrors = response.errors;
        break;

      default:
        unreachable(response);
        break;
    }
  }

  @action
  public handleSendSuccess(passenger: Passenger) {
    this.emailSent = true;
    this.appStore.updatePassenger(passenger);
  }

  @action
  public handleSendError() {
    this.sendError = true;
  }
}



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/components/redeem/send-voucher-store.ts